import {
    createGameInDatabase, getGameMainUserCompany,
    getUserGames,
    markGameAsPlaying,
    saveGameDataToLocalStorage
} from "../modules/games.js";
import {commaSeparate, getCurrentGame, captureError, getTimeDiffHuman} from "../modules/helpers.js";
import {globals, globalUser} from "../modules/globals.js";
import {db, Games, loadDb} from "../models/models.js";
import {loadHomePage} from "./home-page.js";
import {hideMainMenuContent, makeGetRequest, requestTimeout} from "./ui-helpers.js";
import {playSoundEffect} from "./sounds.js"
import {getGameSaveData} from "../modules/games.js"
import {updateLastCloudSave} from "./manage-sub-menu.js";
import {enableTutorialPointerEvents} from "./tutorial.js";
import {loadUser} from "../modules/user.js";

let oldSavesNotieShown = false;
async function continueGameMenuButtonHandler() {
    playSoundEffect('success');

    let $existingGames = $("#existing-games");
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    hideMainMenuContent($());

    // Get games data
    globals.requestRunning = true;
    const gamesData = await getUserGames();
    globals.requestRunning = false;
    notie.hideAlerts();

    let importSaveButton = '';
    if (globalUser.developerMode) {
        importSaveButton = '<label for="import-save-input" class="button retro-button condensed ' +
            'dark-grey-button-background float-right margin-left-3 import-save-label">Import</label>' +
            '<input id="import-save-input" type="file" class="display-none"/>'
    }

    // Add header
    $existingGames.html(
        '<div class="font-bold medium-grey margin-left-2 margin-top-15 margin-bottom-15">' +
            'Local Saves' +
            importSaveButton +
            '<button type="button" class="button retro-button condensed dark-grey-button-background import-cloud-saves-button' +
            ' float-right margin-left-3">Cloud Saves</button>' +
            '<button type="button" class="button retro-button condensed dark-grey-button-background import-main-game-saves-button' +
            ' float-right">Previous Saves</button>' +
        '</div>'
    );

    // Show game box for each game
    let gamesHtml = '';
    gamesData.forEach((gameData) => {
        let gameBoxHtml = getGameBoxHtml(gameData, 'select-game');
        gamesHtml += gameBoxHtml;
    });

    // Show empty game box
    let html;
    if (!globalUser.paid) {
        html = '<div class="game-box empty help-text" title="JoW Paid includes unlimited save slots.">' +
            '<span class="display-block grey">Empty Save Slot</span>' +
            '</div>';
    } else {
        html = '<div class="game-box empty">' +
            '<span class="display-block grey">Empty Save Slot</span>' +
            '</div>';
    }
    gamesHtml += html;

    // Add games boxes
    $existingGames.append('<div class="existing-games-container">' + gamesHtml + '</div>');

    $existingGames.fadeIn('slow');
    $('.existing-games-container').scrollTop(0);

    // Add notie of how to import if no local saves
    if (!gamesData.length && globalUser.loggedIn && !oldSavesNotieShown) {
         notie.alert({type: 4, text: 'No saves? You can import your old saves by clicking on "Previous Saves".'});
         oldSavesNotieShown = true;
    }

    return;
}

function getGameBoxHtml(gameData, gameBoxClass) {

    // Get scenario name and edit name
    let scenarioInfo = gameData.name;
    if (gameData.editName) {
        let editInfo = '<span class="light-grey margin-left-5">"{0}" Edit</span>'.format(gameData.editName);
        scenarioInfo += editInfo;
    }

    // Don't show delete button if showing games to replace
    let deleteButton = '';
    if (gameBoxClass !== 'replace-game') {
        deleteButton = '<button class="button retro-button condensed padding-7-9 display-inline-block ' +
            'margin-bottom-0 red-button-background delete-game-button">Delete</button>'
    }

    // Get sandbox html
    let sandboxHtml = '';
    if (gameData.settings.sandbox_mode_enabled) {
        sandboxHtml = '<div class="margin-top-5 sandbox-mode-color">Sandbox Mode</div>';
    }

    // Get local multiplayer html
    let localMultiplayerHtml = '';
    if (gameData.settings.control_multiple_companies) {
        let playerNamesHtml = '<span class="light-grey margin-left-8">{0}</span>'.format(commaSeparate(gameData.playerNames));
        localMultiplayerHtml = '<div class="margin-top-5 local-multiplayer-mode-color">Local Multiplayer{0}</div>'.format(playerNamesHtml);
    }

    // Get last played html
    let lastPlayed = '';
    if (gameData.lastPlayed) {
        lastPlayed = gameData.lastPlayed
    }

    return '<div class="game-box ' + gameBoxClass + '" data-dbUid="' + gameData.dbUid +
        '" data-company-name="' + gameData.companyName.replace(/"/g, "&quot;") + '" data-game-year="' + gameData.year + '">' +

        // Left column
        '<div class="column-left">' +
        '<span class="display-block margin-bottom-10 font-1p25em line-height-1p4 font-mukta-mahee faded-blue">' +
        gameData.companyName +
        '</span>' +

        '<span class="medium-dark-grey">' +
        gameData.nextEventName + ' (Year ' + gameData.year + ') ' +
        '</span>' +
        '<span class="display-block grey margin-top-5 line-height-1p4">' +
        scenarioInfo +
        '</span>' +
        sandboxHtml +
        localMultiplayerHtml +
        '</div>' +

        // Right column
        '<div class="column-right text-right">' +
        '<div class="grey font-0p925em top-3px">' +
        lastPlayed +
        '</div>' +
        deleteButton +
        '</div>' +

        '<div class="clear"></div>' +

        '</div>';
}

async function selectGameToPlayHandler(el) {
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;

    // Get database by uid
    const dbUid = el.attr('data-dbUid');

    await loadDb(dbUid);

    const game = Games.find({})[0];

    if (!game) {
        notie.alert({type: 3, text: 'That game could not be found. Please try to find it under Cloud Saves.'});
        globals.requestRunning = false;
        playSoundEffect('error');
        return false;
    }
    let mainCompany = await getGameMainUserCompany(game);
    if (!globalUser.paid && ((mainCompany.storyName && mainCompany.storyName !== 'tutorial') ||
        game.settings['sandbox_mode_enabled'] || game.settings['control_multiple_companies'])) {
        notie.alert({
            type: 3, text: 'Stories, sandbox mode and local multiplayer are only available in JoW Paid'
        });
        globals.requestRunning = false;
        playSoundEffect('error');
        return false;
    }

    const user = loadUser();
    if (globalUser.freeTrialActivated && game.userUid && user.uid !== game.userUid) {
        notie.alert({type: 3, text: 'You cannot play games created on another account on the free trial. Please login to that account to play it.'});
        globals.requestRunning = false;
        playSoundEffect('error');
        return false;
    }

    playSoundEffect('success');

    // Set current game
    await markGameAsPlaying(game);

    // Save to local storage
    await saveGameDataToLocalStorage(game);

    // Go to game
    await goToGameFromMainMenu(game);
}

async function goToGameFromMainMenu(game, storyName = null) {  // Previously goToGameFromIntro/startGame
    // Hide main menu, load home page for game
    return $("#existing-games, #new-game-menu, #main-menu, .main-header-container, " +
        ".custom-starting-company-container").fadeOut('fast').promise().done(async function () {
        $('.tutorial-element-outline').hide();
        $('.tutorial-info-container').hide();
        enableTutorialPointerEvents();
        globals.currentTutorialStep = null;
        $('.main-container').addClass('hide-background');
        $("#continue-game").show();

        notie.hideAlerts();
        globals.requestRunning = false;

        // Load story intro page if new story game
        if (storyName === 'passion') {
            // Reset content
            $('.intro-text').hide();
            $('.intro-heading').hide();
            $('.intro-sub-heading').hide();
            $('.intro-continue-button-container').hide();

            // Show heading
            const introHeadingHtml = '<div class="text-center font-1p25em margin-top-40 margin-bottom-2">' +
                'Florida</div>';
            $('.intro-heading').html(introHeadingHtml).fadeIn('slow');
            $('#intro').fadeIn();

            setTimeout(function () {
                // Show subheading
                const introSubHeading = '<div class="text-center margin-bottom-15">March, 1985</div>';
                $('.intro-sub-heading').hide().html(introSubHeading).fadeIn('slow');
                setTimeout(function () {
                    // Show intro text
                    const powIntroText = '<p>It\'s the 80s. Wrestling is booming. A new promotion is looking to rise up, using the talent of their women\'s only cast. And you\'ve just joined as booker.</p>' +
                        '<p>But before it can rise, <span class="pow-color">Passion of Wrestling</span> needs sponsors. And Hank Hughes, a former sci-fi producer and the guy managing the project, has a plan.</p>' +
                        '<p>With the big guns of wrestling running wild, can a small, women\'s promotion even be noticed?</p>';
                    $('.intro-text').html(powIntroText).fadeIn('slow');
                    $('.intro-continue-button-container').hide().fadeIn(1000);
                }, 1600);
            }, 1200);
        }
        // Otherwise load home page
        else {
            await loadHomePage(game);
        }
    });
}

async function importMainGameSavesMenuButtonHandler() {
    makeGetRequest('/_get_user_games', {},
        (data) => {
            playSoundEffect('success');
            hideMainMenuContent($());

            // Add header
            const $accountGames = $('#account-games');
            $accountGames.html(
                '<div class="font-bold blue margin-left-2 margin-top-15 margin-bottom-15">' +
                'Previous Saves' +
                '<button type="button" class="button retro-button condensed dark-grey-button-background back-to-saves-button' +
                ' float-right">Back</button>' +
                '</div>'
            );

            // Add games boxes
            let gamesHtml = '';
            data['games'].forEach((gameData) => {
                let gameBoxHtml = getMainGameSaveHtml(gameData);
                gamesHtml += gameBoxHtml;
            });
            if (!data['games'].length) {
                gamesHtml = '<div class="game-box empty">' +
                    '<span class="display-block grey">Empty Save Slot</span>' +
                    '</div>';
            }
            $accountGames.append('<div class="account-games-container">' + gamesHtml + '</div>');

            $accountGames.fadeIn('slow');
            $('.account-games-container').scrollTop(0);
        });
}

function getMainGameSaveHtml(game) {

    // Get scenario name and edit name
    let scenarioInfo = game['name'];
    if (game['edit_name']) {
        let editInfo = '<span class="light-grey margin-left-5">"{0}" Edit</span>'.format(game['edit_name']);
        scenarioInfo += editInfo;
    }

    // Get sandbox html
    let sandboxHtml = '';
    if (game['settings']['sandbox_mode_enabled']) {
        sandboxHtml = '<div class="margin-top-5 sandbox-mode-color">Sandbox Mode</div>';
    }

    // Get local multiplayer html
    let localMultiplayerHtml = '';
    if (game['settings']['control_multiple_companies']) {
        let playerNamesHtml = '<span class="light-grey margin-left-8">{0}</span>'.format(commaSeparate(game['player_names']));
        localMultiplayerHtml = '<div class="margin-top-5 local-multiplayer-mode-color">Local Multiplayer{0}</div>'.format(playerNamesHtml);
    }

    // Get last played html
    let lastPlayed = '';
    if (game['last_played']) {
        lastPlayed = game['last_played']
    }

    return '<div class="game-box import-main-game-save" data-uid="' + game['uid'] + '">' +

        // Left column
        '<div class="column-left">' +
        '<span class="display-block margin-bottom-10 font-1p25em line-height-1p4 font-mukta-mahee faded-blue">' +
        game['company_name'] +
        '</span>' +

        '<span class="medium-dark-grey">' +
        game['next_event'] + ' (Year ' + game['year'] + ') ' +
        '</span>' +
        '<span class="display-block grey margin-top-5 line-height-1p4">' +
        scenarioInfo +
        '</span>' +
        sandboxHtml +
        localMultiplayerHtml +
        '</div>' +

        // Right column
        '<div class="column-right text-right">' +
        '<div class="grey font-0p925em top-3px">' +
        lastPlayed +
        '</div>' +
        '</div>' +

        '<div class="clear"></div>' +

        '</div>';
}

async function importMainGameSave(uid) {
    playSoundEffect('success');

    makeGetRequest('/_get_game_export_data', {uid: uid},
        async (data) => {
            if (!data['error']) {
                await checkGetGameExportDataJob(data['statusUrl']);
            } else {
                notie.hideAlerts();
                globals.requestRunning = false;
                playSoundEffect('error');
                if (data['error'] === 'not-logged-in') {
                    notie.alert({
                        type: 3, text: 'You need to be logged in to import your account\'s save games.',
                        stay: true
                    });
                } else if (data['error'] === 'game-not-found') {
                    notie.alert({
                        type: 3, text: 'That game could not be found. Please try again.',
                        stay: true
                    });
                }
                else if (data['error'] === 'story') {
                    notie.alert({
                        type: 3, text: 'This story is not supported yet.',
                        stay: true
                    });
                }
                else if (data['error'] === 'paid-only') {
                    notie.alert({
                        type: 3, text: 'Stories, sandbox mode and local multiplayer are only available in JoW Paid'
                    });
                }
            }
        }, true, 'Loading save data. This can take some time, depending on the size of the save.');
}

async function checkGetGameExportDataJob(statusUrl) {
    makeGetRequest(statusUrl, {}, async (data) => {
        switch (data.status) {
            case "unknown":
            case "failed":
                notie.hideAlerts();
                globals.requestRunning = false;
                playSoundEffect('error');

                notie.alert({type: 3, text: "There was an error. Please try again"});
                break;
            case "finished":
                // Create game
                notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>' +
                        'Importing save. This can take some time, depending on the size of the save.', stay: true});

                try {
                    await createGameInDatabase(data['result']);
                    globals.requestRunning = false;

                    // Go back to saves
                    await continueGameMenuButtonHandler();
                }
                catch (error) {
                    captureError(error);
                    globals.requestRunning = false;
                    notie.alert({type: 3, text: "There was an error importing the game."})
                }

                break;
            default:
                setTimeout(async function () {
                    await checkGetGameExportDataJob(statusUrl);
                }, 1000);
        }
    }, true, null, false);
}

async function importCloudSavesMenuButtonHandler() {
    makeGetRequest('/_get_cloud_saves', {},
        (data) => {
            if (!data['error']) {
                playSoundEffect('success');
                hideMainMenuContent($());

                // Add header
                const $accountGames = $('#account-games');
                $accountGames.html(
                    '<div class="font-bold blue margin-left-2 margin-top-15 margin-bottom-15">' +
                    'Cloud Saves' +
                    '<button type="button" class="button retro-button condensed dark-grey-button-background back-to-saves-button' +
                    ' float-right">Back</button>' +
                    '</div>'
                );

                // Add games html
                let gamesHtml = '';
                data.forEach((gameData) => {
                    let gameBoxHtml = getCloudSaveHtml(gameData);
                    gamesHtml += gameBoxHtml;
                });
                if (!data.length) {
                    gamesHtml = '<div class="game-box empty">' +
                        '<span class="display-block grey">Empty Save Slot</span>' +
                        '</div>';
                }

                $accountGames.append('<div class="account-games-container">' + gamesHtml + '</div>');

                $accountGames.fadeIn('slow');
                $('.account-games-container').scrollTop(0);
            }
            else {
                playSoundEffect('error');
                if (data['error'] === 'not-logged-in') {
                    notie.alert({
                        type: 3, text: 'You need to login to view cloud saves.'
                    });
                }
            }
        });
}

function getCloudSaveHtml(game) {

    // Get scenario name and edit name
    let scenarioInfo = game['name'];
    if (game['editName']) {
        let editInfo = '<span class="light-grey margin-left-5">"{0}" Edit</span>'.format(game['editName']);
        scenarioInfo += editInfo;
    }

    // Get sandbox html
    let sandboxHtml = '';
    if (game['settings']['sandbox_mode_enabled']) {
        sandboxHtml = '<div class="margin-top-5 sandbox-mode-color">Sandbox Mode</div>';
    }

    // Get local multiplayer html
    let localMultiplayerHtml = '';
    if (game['settings']['control_multiple_companies']) {
        let playerNamesHtml = '<span class="light-grey margin-left-8">{0}</span>'.format(commaSeparate(game['playerNames']));
        localMultiplayerHtml = '<div class="margin-top-5 local-multiplayer-mode-color">Local Multiplayer{0}</div>'.format(playerNamesHtml);
    }

    // Get last played html
    let lastPlayed = '';
    if (game['datetimeLastPlayed']) {
        lastPlayed = getTimeDiffHuman(game['datetimeLastPlayed'], new Date()) + ' ago'
    }

    let deleteButton = '<button class="button retro-button condensed padding-7-9 display-inline-block ' +
            'margin-bottom-0 blue-button-background delete-cloud-save-button">Delete</button>';

    return '<div class="game-box import-cloud-save" data-filename="' + game['filename'] +
        '" data-company-name="' + game['companyName'].replace(/"/g, "&quot;") + '" data-game-year="' + game['year'] + '">' +

        // Left column
        '<div class="column-left">' +
        '<span class="display-block margin-bottom-10 font-1p25em line-height-1p4 font-mukta-mahee faded-blue">' +
        game['companyName'] +
        '</span>' +

        '<span class="medium-dark-grey">' +
        game['nextEventName'] + ' (Year ' + game['year'] + ') ' +
        '</span>' +
        '<span class="display-block grey margin-top-5 line-height-1p4">' +
        scenarioInfo +
        '</span>' +
        sandboxHtml +
        localMultiplayerHtml +
        '</div>' +

        // Right column
        '<div class="column-right text-right">' +
        '<div class="grey font-0p925em top-3px">' +
        lastPlayed +
        '</div>' +
        deleteButton +
        '</div>' +

        '<div class="clear"></div>' +

        '</div>';
}

async function importCloudSave(filename) {
    if (globals.requestRunning) {
        return false;
    }
    playSoundEffect('success');

    makeGetRequest('/_load_game_data_from_cloud', {filename: filename}, async (data) => {
        if (!data['error']) {
            await checkLoadGameDataFromCloudJob(data['statusUrl']);
        }
        else {
            notie.hideAlerts();
            globals.requestRunning = false;
            playSoundEffect('error');
            if (data['error'] === 'not-logged-in') {
                notie.alert({
                    type: 4, text: 'You need to login to load save data from the cloud.'
                });
            }
        }
    }, true);
}

async function checkLoadGameDataFromCloudJob(statusUrl) {
    makeGetRequest(statusUrl, {}, async (data) => {
        switch (data.status) {
            case "unknown":
            case "failed":
                notie.hideAlerts();
                globals.requestRunning = false;
                playSoundEffect('error');

                notie.alert({type: 3, text: "There was an error. Please try again"});
                break;
            case "finished":
                // Convert base64 string to array buffer, decompress
                const arrayBuffer = base64ToArrayBuffer(data['result']);
                await loadGameFromCompressedSaveData(arrayBuffer);
                break;
            default:
                setTimeout(async function () {
                    await checkLoadGameDataFromCloudJob(statusUrl);
                }, 1000);
        }
    }, true, null, false);
}

async function deleteCloudSave(filename, parent) {
    if (globals.requestRunning) {
        return false;
    }

    makeGetRequest('/_delete_cloud_save', {filename: filename}, async (data) => {
        if (!data['error']) {
            playSoundEffect('success');
            notie.alert({type: 4, text: "Cloud save deleted"});
            parent.remove();

            // Add empty text if no cloud saves left
            if (!$('.account-games-container .game-box').length) {
                $('.account-games-container').html(
                    '<div class="game-box empty">' +
                    '<span class="display-block grey">Empty Save Slot</span>' +
                    '</div>'
                )
            }
        }
        else {
            playSoundEffect('error');
            notie.alert({
                type: 3, text: 'Deleting cloud save failed. Please try again.'
            });
            captureError(new Error('error for delete cloud save request: ' + data['error']));
        }
    });
}

async function saveGameDataBaseToCloud(showLoading = true, setDatetimeLastPlayed = false) {
    if (globals.cloudSaveRequestRunning) {
        if (showLoading) {
            notie.alert({
                type: 4, text: 'A cloud save is already in progress'
            });
        }
        return false;
    }

    // Don't save if offline
    if (!window.navigator.onLine) {
        if (showLoading) {
            notie.alert({type: 3, text: 'Could not save to the cloud because you\'re offline.', stay: true});
        }
        else {
            notie.alert({type: 3, text: 'WARNING! Could not save to the cloud because you\'re offline. Please save after going online as local save data can be lost.', stay: true});
        }

        return false;
    }

    const currentGame = await getCurrentGame();

    // Get database json string
    let databaseJSON = db.serialize();

    // Set datetimeLastPlayed
    if (setDatetimeLastPlayed) {
        currentGame.datetimeLastPlayed = Date.now();
    }

    // Get game save data
    const gameSaveData = await getGameSaveData(currentGame);
    delete gameSaveData['uid'];
    gameSaveData['filename'] = db.filename;

    if (showLoading) {
        notie.alert({
            type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Saving to cloud. This runs in the ' +
                'background so you can continue playing.',
            stay: true
        });
    }

    // Compress
    const databaseJSONArrayBuffer = fflate.strToU8(databaseJSON);
    fflate.compress(databaseJSONArrayBuffer, (err, compressed) => {
        if (err) {
            notie.alert({
                type: 3, text: 'Cloud save compression failed.'
            });
            captureError(new Error('error for cloud save compression: ' + err));
            return;
        }

        // Send as form data
        let compressedDatabaseJSON = new Blob([compressed]);
        let formData = new FormData();
        formData.append("databaseJSON", compressedDatabaseJSON);
        formData.append("gameSaveData", JSON.stringify(gameSaveData));

        globals.cloudSaveRequestRunning = true;
        $.ajax({
            type: "POST",
            contentType: false,
            processData: false,
            url: globals.baseUrl + '/_save_game_data_to_cloud',
            data: formData,
            success: async function (data) {
                if (!data['error']) {
                    await checkSaveGameDataToCloudJob(data['statusUrl'], currentGame, showLoading);
                }
                else {
                    playSoundEffect('error');
                    globals.cloudSaveRequestRunning = false;
                    if (data['error'] === 'max-limit') {
                        let notieText= 'Maximum cloud saves (' + data['max_cloud_saves'] + ') reached. Please delete an existing ' +
                                'cloud save if you want to save this game\'s data to the cloud.'
                        if (data['max_cloud_saves'] === 1) {
                            notieText += ' JoW Paid allows 10 cloud saves.'
                        }
                        notie.alert({
                            type: 3, text: notieText
                        });
                    }
                    else if (data['error'] === 'not-logged-in') {
                        notie.alert({
                            type: 4, text: 'Please login if you want to save your game\'s data to the cloud.'
                        });
                    }
                    else if (data['error'] === 'paid-only') {
                        notie.alert({
                            type: 3, text: 'Stories, sandbox mode and local multiplayer are only available in JoW Paid'
                        });
                    }
                    else {
                        if (showLoading) {
                            notie.alert({
                                type: 3, text: 'Cloud save failed. Please try again.', stay: true
                            });
                        }
                        else {
                            notie.alert({
                                type: 3, text: 'WARNING! Cloud save failed. Please try again as local save data can be lost.', stay: true
                            });
                        }
                        captureError(new Error('error for cloud save request: ' + data['error']));
                    }
                }
            },
            dataType: "json",
            timeout: requestTimeout,
            error: function (jqXHR, status, errorThrown) {
                playSoundEffect('error');
                globals.cloudSaveRequestRunning = false;
                if (status === 'timeout') {
                    notie.alert({type: 3, text: 'The cloud save request timed out. Please try again in a while.'});
                }
                else {
                    notie.alert({type: 3, text: 'There was an error with the cloud save request. Please try again in a while.'});
                }
                captureError(new Error('error for cloud save request: ' + errorThrown));
            }
        });
    });
}

async function checkSaveGameDataToCloudJob(statusUrl, currentGame, showLoading) {
    $.ajax({
        url: globals.baseUrl + statusUrl,
        dataType: 'json',
        success: async (data) => {
            switch (data.status) {
                case "unknown":
                case "failed":
                    playSoundEffect('error');
                    globals.cloudSaveRequestRunning = false;
                    if (showLoading) {
                        notie.alert({
                            type: 3, text: 'Cloud save failed. Please try again.', stay: true
                        });
                    }
                    else {
                        notie.alert({
                            type: 3, text: 'WARNING! Cloud save failed. Please try again as local save data can be lost.', stay: true
                        });
                    }
                    break;
                case "finished":
                    globals.cloudSaveRequestRunning = false;
                    if (!data['result']['error']) {
                        playSoundEffect('success');
                        notie.alert({type: 1, text: "Game data saved to the cloud"});

                        // Set dateTimeLastCloudSave
                        currentGame.dateTimeLastCloudSave = Date.now();
                        db.saveDatabase();

                        await saveGameDataToLocalStorage(currentGame);

                        updateLastCloudSave(currentGame.dateTimeLastCloudSave);
                    } else {
                        playSoundEffect('error');
                        if (showLoading) {
                            notie.alert({
                                type: 3, text: 'Cloud save failed. Please try again.', stay: true
                            });
                        }
                        else {
                            notie.alert({
                                type: 3, text: 'WARNING! Cloud save failed. Please try again as local save data can be lost.', stay: true
                            });
                        }
                        captureError(new Error('error for cloud save request job: ' + data['result']['error']));
                    }
                    break;
                default:
                    setTimeout(async function () {
                        await checkSaveGameDataToCloudJob(statusUrl, currentGame);
                    }, 1000);
            }
        },
        timeout: requestTimeout,
        error: function (jqXHR, status, errorThrown) {
            playSoundEffect('error');
            globals.cloudSaveRequestRunning = false;
            if (showLoading) {
                notie.alert({
                    type: 3, text: 'There was an error with the cloud save request. Please try again.', stay: true
                });
            }
            else {
                notie.alert({
                    type: 3, text: 'WARNING! There was an error with the cloud save request. Please try again as local save data can be lost.', stay: true
                });
            }
            captureError(new Error('error for cloud save request job: ' + errorThrown));
        }
    });
}

function base64ToArrayBuffer(base64) {
    let binaryString = atob(base64);
    let bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

async function downloadGameDatabase() {
    const currentGame = await getCurrentGame();
    let databaseJSON = db.serialize();
    currentGame.datetimeLastPlayed = Date.now();
    const databaseJSONArrayBuffer = fflate.strToU8(databaseJSON);
    fflate.compress(databaseJSONArrayBuffer, (err, compressed) => {
        if (err) {
            notie.alert({
                type: 3, text: 'Save compression failed.'
            });
            captureError(new Error('error for save compression: ' + err));
            return;
        }
        let blob = new Blob([compressed]);
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = db.filename;
        a.click();
        URL.revokeObjectURL(a.url);
    });
}

async function loadGameFromCompressedSaveData(arrayBuffer) {
    // Decompress and convert to json string
    fflate.decompress(arrayBuffer, async (err, decompressed) => {
        if (err) {
            notie.hideAlerts();
            globals.requestRunning = false;
            notie.alert({
                type: 3, text: 'Cloud save decompression failed.'
            });
            captureError(new Error('error for cloud save decompression: ' + err));
            return;
        }

        const databaseJSON = fflate.strFromU8(decompressed);

        // Create/load db for game
        const dbData = JSON.parse(databaseJSON);
        const filename = dbData.filename;
        await loadDb(filename, dbData);

        notie.hideAlerts();
        globals.requestRunning = false;

        // Set datetimeLastPlayed and save
        const game = Games.find({})[0];
        await markGameAsPlaying(game);

        // Save to local storage
        await saveGameDataToLocalStorage(game, filename);

        // Go back to saves
        await continueGameMenuButtonHandler();
    });
}

export {continueGameMenuButtonHandler, selectGameToPlayHandler, goToGameFromMainMenu, importMainGameSavesMenuButtonHandler,
    importMainGameSave, saveGameDataBaseToCloud, importCloudSavesMenuButtonHandler, importCloudSave, deleteCloudSave,
    downloadGameDatabase, loadGameFromCompressedSaveData}